module.exports = __webpack_public_path__ + "img/a89e45a.png";